import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { HelpIcon } from '@dixa/lib-shared-habla';
import Spinner from '../../ajax/components/Spinner';
import Switch from '../switch/Switch';
import './styles/dixa-switch.less';
const DixaSwitch = ({ name, displayName, hidden, disabled, input, meta, showSpinner, className, isChecked, showHelpIcon, helpIconTitle, helpIconText, labelA, labelB, onChangeAction, onBlurAction, controlled, }) => {
    let formGroupClasses = className && typeof className === 'string' ? className : '';
    let validationErrors = null;
    let spinner = null;
    let helpIcon = null;
    let checked = false;
    if (controlled) {
        checked = typeof isChecked === 'boolean' ? isChecked : input.value;
    }
    else {
        checked = input.value === '' ? isChecked : input.value;
    }
    if (meta !== undefined && meta.touched === true && meta.valid === true) {
        formGroupClasses += ' has-success';
    }
    else if (meta !== undefined && meta.touched === true && meta.error) {
        formGroupClasses += ' has-error';
        validationErrors = _jsx("span", Object.assign({ className: "validation-text" }, { children: meta.error }));
    }
    if (hidden) {
        formGroupClasses += ' hidden';
    }
    if (disabled) {
        formGroupClasses += ' disabled';
    }
    if (showSpinner) {
        spinner = _jsx(Spinner, { className: "dark input" });
    }
    if (showHelpIcon) {
        helpIcon = (_jsx("div", Object.assign({ className: "helpIcon" }, { children: _jsx(HelpIcon, { text: helpIconText, title: helpIconTitle }) })));
    }
    input.value === '' ? isChecked : input.value;
    return (_jsxs("div", Object.assign({ className: 'form-group dixa-switch ' + formGroupClasses }, { children: [_jsxs("label", Object.assign({ className: "control-label pull-left", htmlFor: name }, { children: [displayName, " ", validationErrors] })), _jsxs("div", Object.assign({ className: "pull-right onselect" }, { children: [_jsx(Switch, { id: name, value: input.value, onBlur: (e) => {
                            if (typeof onBlurAction === 'function') {
                                onBlurAction(e);
                            }
                            input.onBlur(e);
                        }, onFocus: (e) => {
                            input.onFocus(e);
                        }, disabled: disabled, onChange: ((e) => {
                            if (typeof onChangeAction === 'function') {
                                onChangeAction(e);
                            }
                            input.onChange(e);
                        }), checked: checked, labelA: labelA, labelB: labelB }), spinner] })), helpIcon] })));
};
DixaSwitch.defaultProps = {
    controlled: false, // https://reactjs.org/docs/uncontrolled-components.html
};
export default DixaSwitch;
